import api from '../api/axios';

export interface DevPersona {
  rut: number;
  nombre: string;
  n: number;
}

export type DevTipo = 'estudiante' | 'docente';

export const devService = {
  /** Lista Personas reales para el switcher. Lanza 404 si el dev-login está deshabilitado. */
  listPersonas: async (tipo: DevTipo, q = ''): Promise<DevPersona[]> => {
    const { data } = await api.get<{ tipo: DevTipo; personas: DevPersona[] }>('dev/personas/', { params: { tipo, q } });
    return data.personas;
  },

  /** Inicia sesión como una Persona (`{rut}`) o como coordinador (`{coordinador: true}`). */
  loginAs: async (payload: { rut: number } | { coordinador: true }): Promise<void> => {
    await api.post('dev/login-as/', payload);
  },
};
